import camelCase from "lodash/camelCase";
import { useCustomTypes } from "PFCore/helpers/use_custom_types";
import { NotificationSetting } from "PFTypes";
import { useTranslation } from "react-i18next";
import { humanize } from "underscore.string";

const CHANGED_SUFFIX = "_changed";

const extractCustomFieldName = (category: string, group: string): string => {
  const prefix = `${group}_`;
  const withoutPrefix = category.startsWith(prefix) ? category.slice(prefix.length) : category;
  return withoutPrefix.endsWith(CHANGED_SUFFIX)
    ? withoutPrefix.slice(0, -CHANGED_SUFFIX.length)
    : withoutPrefix;
};

export const useNotificationCategoryLabel = () => {
  const { t } = useTranslation("notificationsSettings");
  const { getCustomTypeByName } = useCustomTypes();

  return ({ category, group }: NotificationSetting): string => {
    if (group) {
      const customFieldName = extractCustomFieldName(category, group);
      const customType = getCustomTypeByName(customFieldName);
      return customType?.display_as ?? humanize(customFieldName);
    }

    const key = camelCase(category);
    return t(`category.${key}` as unknown as TemplateStringsArray, {
      defaultValue: humanize(category)
    }) as string;
  };
};
